import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("fa_cart") || "[]"));

  useEffect(() => {
    localStorage.setItem("fa_cart", JSON.stringify(items));
  }, [items]);

  const inCart = (id) => items.some((i) => i.id === id);
  const toggle = (photo) =>
    setItems((prev) =>
      prev.some((i) => i.id === photo.id)
        ? prev.filter((i) => i.id !== photo.id)
        : [...prev, { id: photo.id, price: photo.price, event_title: photo.event_title, photographer_name: photo.photographer_name }]
    );
  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const removeMany = (ids) => setItems((prev) => prev.filter((i) => !ids.includes(i.id)));
  const clear = () => setItems([]);
  const total = items.reduce((s, i) => s + i.price, 0);

  return (
    <CartContext.Provider value={{ items, inCart, toggle, remove, removeMany, clear, total }}>{children}</CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
